'use client';

/* จับคู่การ์ด/สไลด์บนหน้าแรก (ข้อมูลนิ่งในโค้ด) กับเกมจริงของหลังบ้าน usun
   - ชื่อเกมตรง        → เข้าเกมนั้นเลย ({gameName: ค่าย, gameCode})
   - ชื่อค่ายตรง       → เข้าล็อบบี้ค่ายนั้น
   - ไม่ตรงสักอย่าง    → ทางเข้าตรง usun (launchGame() ค่าเริ่มต้น = USUN)
   แคทาล็อกโหลดครั้งเดียวต่อการเปิดหน้า (route /api/games แคช 10 นาทีอยู่แล้ว) */

const norm = (s) => String(s || '').toLowerCase()
  .replace(/^webbanner[-_ ]+/, '')                       // ชื่อไฟล์แบนเนอร์ เช่น webbanner-Tornado-Rampage
  .replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ')
  .replace(/\b(slot|slots|game|games|the|of)\b/g, ' ')
  .replace(/\s+/g, ' ').trim();
// คีย์สำรองแบบไม่มีช่องว่าง — "Mahjong Ways2" ต้องเจอ "Mahjong Ways 2"
const tight = (s) => norm(s).replace(/ /g, '');

// ชื่อค่ายบนเว็บ ↔ รหัสค่ายของหลังบ้าน (ตัวที่สะกดไม่ตรงกัน)
const PROVIDER_ALIAS = {
  'pretty gaming': 'PRETTY_LIVE', pretty: 'PRETTY_LIVE',
  'sa gaming': 'SA', 'sexy baccarat': 'SA',
  'pg soft': 'PG', pgsoft: 'PG', pg: 'PG',
  'pragmatic play': 'PRG', 'dream gaming': 'DG', 'wm casino': 'WM',
};

let catalogPromise = null;

export function loadCatalog() {
  if (catalogPromise) return catalogPromise;
  catalogPromise = (async () => {
    const byName = new Map(), byTight = new Map(), providers = [];
    const d = await fetch('/api/games').then((r) => r.json()).catch(() => null);
    for (const tab of d?.tabs || []) {
      for (const p of tab.providers || []) providers.push({ provider: p.provider, name: p.name, tab: tab.key, count: p.count });
    }
    const withGames = [...new Map(providers.filter((p) => p.count > 0).map((p) => [p.provider, p])).values()].slice(0, 14);
    await Promise.all(withGames.map(async (p) => {
      const g = await fetch(`/api/games?provider=${encodeURIComponent(p.provider)}`).then((r) => r.json()).catch(() => null);
      for (const item of g?.games || []) {
        const hit = { provider: p.provider, code: item.code, name: item.name };
        const k = norm(item.name), t = tight(item.name);
        if (k && !byName.has(k)) byName.set(k, hit);
        if (t && !byTight.has(t)) byTight.set(t, hit);
      }
    }));
    return { byName, byTight, providers };
  })();
  return catalogPromise;
}

export function findProvider(providers, name) {
  const want = norm(name);
  if (!want) return null;
  const alias = PROVIDER_ALIAS[want];
  if (alias) { const p = providers.find((x) => x.provider === alias); if (p) return p; }
  return providers.find((x) => norm(x.name) === want)
    || providers.find((x) => norm(x.provider) === want)
    || providers.find((x) => norm(x.name).includes(want) || want.includes(norm(x.name)))
    || null;
}

/* การ์ดใบนี้ควรเปิดอะไร → { gameName?, gameCode?, exact }
   gameName ว่าง = ทางเข้าตรง usun (ให้ launchGame ใช้ค่าเริ่มต้น) */
export async function resolveTarget({ game, provider, hint } = {}) {
  const { byName, byTight, providers } = await loadCatalog();

  if (game) {
    const g = byName.get(norm(game)) || byTight.get(tight(game));
    if (g) return { gameName: g.provider, gameCode: g.code, exact: true, label: g.name };
  }
  // ชื่อเกมไม่เจอ แต่รู้ค่ายจากชื่อไฟล์ (เช่น *_pgslot.webp) → เข้าล็อบบี้ค่ายนั้น
  const p = findProvider(providers, provider || hint);
  if (p) return { gameName: p.provider, exact: false, label: p.name };

  return { exact: false, label: 'usun' };   // ทางเข้าตรง
}
